import { fromJS } from 'immutable'
import * as constants from './constants'

const defaultState = fromJS({
  searchParams: null
})

export default (state = defaultState, action) => {
  const { type, value } = action
  switch (type) {
    case constants.CHANGE_SEARCH_PARAMS:
      return state.set('searchParams', value)
    default:
      return state
  }
}
